import createGetFormError from './selectors/getFormError';
import plain from './structure/plain';

export default createGetFormError(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/getFormError.js
// module id = 1751
// module chunks = 2